var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MuiThemeProvider, useTheme, } from '@material-ui/core';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import muiTheme from './theme';
var MuiToSCThemeProvider = function (props) {
    var themeProvidedByMuiThemeProvider = useTheme();
    var styledComponentsOverrides = {}; // put default styled components overrides here
    if (typeof themeProvidedByMuiThemeProvider === 'function') {
        themeProvidedByMuiThemeProvider = themeProvidedByMuiThemeProvider(muiTheme);
    }
    return (React.createElement(SCThemeProvider, __assign({}, props, { theme: __assign(__assign({}, themeProvidedByMuiThemeProvider), styledComponentsOverrides) })));
};
// Kareo Theme provider combines Material UI Theme Provider and Styled component theme provider
// this allows the theme to be used for material-ui components as well as styled components
var ThemeProvider = function (_a) {
    var children = _a.children, theme = _a.theme, props = __rest(_a, ["children", "theme"]);
    // theme can be a function or an object
    var themeProviderTheme = theme || muiTheme;
    if (typeof theme === 'function') {
        themeProviderTheme = theme(muiTheme);
    }
    return (React.createElement(MuiThemeProvider, __assign({ theme: themeProviderTheme }, props),
        React.createElement(MuiToSCThemeProvider, null, children)));
};
export default ThemeProvider;
